import React from "react";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import {AppState} from "../RootReducer";
import {setWindowSizeBr} from "../settings/SettingsActions";
import {WindowSize} from "../settings/SettingsReducer";
import {Device} from "../utils/Device";


interface Props {
    windowSize: number;
    setWindowSizeBr: (windowSize: number, mobile : boolean) => void;
}
export class WindowSizeContainer extends React.Component<Props> {
    constructor(props : Props) {
        super(props);
    }
    componentDidMount(): void {
        // Should probably have another system here
        this.resize("start");
        window.addEventListener("resize", this.resize);

    }
    componentWillUnmount(): void {
        window.removeEventListener("resize", this.resize);
    }

    resize = (value: any): any => {
        if(window.innerWidth >= WindowSize.WIDTH_XL) {
            if(!(this.props.windowSize === WindowSize.WIDTH_XL)) {
                this.props.setWindowSizeBr(WindowSize.WIDTH_XL, windowSize.isMobile(window.innerWidth));
            }
        } else if(window.innerWidth >= WindowSize.WIDTH_LG) {
            if(!(this.props.windowSize === WindowSize.WIDTH_LG)) {
                this.props.setWindowSizeBr(WindowSize.WIDTH_LG, windowSize.isMobile(window.innerWidth));
            }
        } else if(window.innerWidth >= WindowSize.WIDTH_MD) {
/*             if(!(this.props.windowSize === WindowSize.WIDTH_MD)) {
                this.props.setWindowSizeBr(WindowSize.WIDTH_MD, windowSize.isMobile(window.innerWidth));
            } */
        } else if(window.innerWidth >= WindowSize.WIDTH_SM) {
            if(!(this.props.windowSize === WindowSize.WIDTH_SM)) {
                this.props.setWindowSizeBr(WindowSize.WIDTH_SM, windowSize.isMobile(window.innerWidth));
            }
        } else if(window.innerWidth >= WindowSize.WIDTH_XS) {
            if(!(this.props.windowSize === WindowSize.WIDTH_XS)) {
                this.props.setWindowSizeBr(WindowSize.WIDTH_XS, windowSize.isMobile(window.innerWidth));
            }
        }  else {
            this.props.setWindowSizeBr(WindowSize.WIDTH_XS, windowSize.isMobile(window.innerWidth));
        }
    }

    render() {
        return (
            <div />
        )
    }
}

const mapDispatchToProps = (dispatch : Dispatch) => (
    {
        setWindowSizeBr: (windowSize: number, mobile : boolean) => dispatch(setWindowSizeBr(windowSize, mobile)),
    }
);

let mapStateToProps = (app : AppState)=> {
    return {windowSize: app.settings.windowSize}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WindowSizeContainer);


export class windowSize {
  public static isMobile(screen: number) {
    const isLandscape = window.matchMedia("(orientation: landscape)").matches;

    if (isLandscape) return screen <= WindowSize.WIDTH_LG;
    return screen <= WindowSize.WIDTH_SM;
  }
  public static isTablet(screen: number) {
    return screen <= WindowSize.WIDTH_MD && screen >= WindowSize.WIDTH_SM;
  }
  public static isDesktop(screen: number) {
    return screen >= WindowSize.WIDTH_MD;
  }
}
